import React, { Component } from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  sectionPart: {
    textAlign: "center",
    display: "inline-block",
    width: "100%",
  },
  closingLine: {
    fontSize: 12,
  },
  sectionTextPart: {
    marginLeft: 15,
    textAlign: "left",
    display: "inline-block",
    width: "100%",
  },
});

class GameScoreResultRow extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      `${nextProps.IdGame}${nextProps.index}` !==
      `${this.props.IdGame}${this.props.index}`
    );
  }
  render() {
    const { scoreRow, classes } = this.props;
    const gradedDate = scoreRow.GradedDate.split(" ");
    const gameDateTime = scoreRow.GameDateTime.split(" ");
    return (
      <TableRow>
        <TableCell padding="none">{scoreRow.IdSport}</TableCell>
        <TableCell padding="none">
          {gameDateTime[0]} <br />
          {gameDateTime[1]}
        </TableCell>
        <TableCell padding="none">
          <span className={classes.sectionTextPart}>
            {scoreRow.VisitorName}
          </span>
          <span className={classes.sectionTextPart}>{scoreRow.HomeName}</span>
        </TableCell>
        <TableCell padding="none">
          <span className={classes.sectionPart}>{scoreRow.GVisitorScore}</span>
          <span className={classes.sectionPart}>{scoreRow.GHomeScore}</span>
        </TableCell>
        <TableCell padding="none">
          <span className={classes.sectionPart}>{scoreRow.VisitorScore1H}</span>
          <span className={classes.sectionPart}>{scoreRow.HomeScore1H}</span>
        </TableCell>
        <TableCell padding="none">
          <span className={classes.sectionPart}>{scoreRow.VisitorScore2H}</span>
          <span className={classes.sectionPart}>{scoreRow.HomeScore2H}</span>
        </TableCell>
        <TableCell padding="none">
          <span className={classes.sectionPart}>{scoreRow.VisitorScore1P}</span>
          <span className={classes.sectionPart}>{scoreRow.HomeScore1P}</span>
        </TableCell>
        <TableCell padding="none">
          <span className={classes.sectionPart}>{scoreRow.VisitorScore2P}</span>
          <span className={classes.sectionPart}>{scoreRow.HomeScore2P}</span>
        </TableCell>
        <TableCell padding="none">
          <span className={classes.sectionPart}>{scoreRow.VisitorScore3P}</span>
          <span className={classes.sectionPart}>{scoreRow.HomeScore3P}</span>
        </TableCell>
        <TableCell padding="none">
          <span className={classes.sectionPart}>{scoreRow.VisitorScore4P}</span>
          <span className={classes.sectionPart}>{scoreRow.HomeScore4P}</span>
        </TableCell>
        <TableCell padding="none">
          {gradedDate[0]} <br />
          {gradedDate[1]}
        </TableCell>
        <TableCell padding="none">
          {scoreRow.VisitorSpread && (
            <div className={classes.closingLine}>
              Visitor Spread: {scoreRow.VisitorSpread}
            </div>
          )}
          {scoreRow.HomeSpread && (
            <div className={classes.closingLine}>
              Home Spread: {scoreRow.HomeSpread}
            </div>
          )}
          {scoreRow.TotalOver && (
            <div className={classes.closingLine}>
              Total Over: {scoreRow.TotalOver}
            </div>
          )}
          {scoreRow.TotalUnder && (
            <div className={classes.closingLine}>
              Total Under: {scoreRow.TotalUnder}
            </div>
          )}
        </TableCell>
      </TableRow>
    );
  }
}

GameScoreResultRow.propTypes = {
  scoreRow: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default withStyles(styles, { withTheme: true })(GameScoreResultRow);
